import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
import { Icon, Tooltip, Dropdown, Picker, Loading } from "@ss/mtd-react3";
import BrandSearch from "./BrandSearch/index.jsx";
import CollectionDetail from "./CollectionDetail/index.jsx";
import Rectangle from "../../assets/images/Rectangle.png";
import RectangleBlack from "../../assets/images/RectangleBlack.png";
import { sortBySortOrder } from '@/utils/tree';
import {
    getAssetsDetail,
    searchCollectionData
} from "@/api/BrandAggregation/collection.js";
import noContent from "@/assets/images/no-content.png";

import "./style.scss";
import { getUserInfo } from "@/utils/index";
import { fetchData } from "@/utils";
import urls from "@/urls";
import EllipsisTooltip from "@/components/tooltip/ellipsis-tooltip";
import CardList from "@/components/cardList/index.jsx";

const data = [
    { label: "Default", value: "Default" },
    { label: "Recently Updated", value: "Recently Updated" },
    { label: "Most Downloaded", value: "Most Downloaded" },
    { label: "Most Viewed", value: "Most Viewed" }
];
// 添加排序参数映射
const sortMapping = {
    "Default": "default",
    "Recently Updated": "updateTime",
    "Most Downloaded": "downloadNum",
    "Most Viewed": "browseNum"
};
const formatter = value => {
    return (
        <span>
            <span
                style={{
                    color: "rgba(17, 25, 37, 0.65)",
                    marginRight: "7px"
                }}
            >
                Sort by
            </span>
            {value.value}
        </span>
    );
};
// const navItems = [
//     { id: "all", label: "All" },
//     { id: "introduction", label: "Introduction" },
//     { id: "logo", label: "Logo" },
//     { id: "color", label: "Color" },
//     { id: "typography", label: "Typography" },
//     { id: "graphic", label: "Graphic" },
//     {
//         id: "social-media",
//         label: "Social Media Avatars"
//     },
//     { id: "collections", label: "Collections" }
// ];

export default class BrandAggregation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showDetail: false, // 显示合集详情
            collectionObj: {},
            keyword: "",
            activeNav: "all", // 添加导航激活状态
            collectSortValue: "Recently Updated",
            CollectionData: null,
            page: 1,
            pageSize: 23,
            sortCol: "updateTime",
            hasMore: true,
            loading: false,
            assetSortValue: "Default",
            assetSortCol: "default",
            assetsList: [], // assets列表数据
            directoryId: "",
            assetPage: 1,
            navItems: [], // 目录数据
            assetPageSize: 9999,
            total: 0,
            pageLoading: true, // 添加页面初始加载状态
            navItemRefs: {}
        };
        this.navItemRefs = {};
        this.cardListRef = React.createRef(); // 添加ref
    }
    async componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        // 组件挂载时，从路由参数获取 type
        const { state } = this.props.history.location;
        await this.getDirectoryList();
        try {
            if (state?.type) {
                const { navItems } = this.state;

                if (
                    !navItems?.some(e =>
                        e.label.toLowerCase().includes(state.type.toLowerCase())
                    )
                ) {
                    this.setState({ activeNav: "all" }, () => {
                        // all 时调用两个接口
                        this.searchCollectionData();
                        this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
                    });
                } else {
                    const matchedNav = navItems.find(e =>
                        e.label.toLowerCase().includes(state.type.toLowerCase())
                    );
                    const navId = matchedNav?.id || "all";

                    this.setState({ activeNav: navId }, () => {
                        // 根据导航 ID 调用对应接口
                        if (navId === "all") {
                            this.searchCollectionData();
                            this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
                        } else if (navId === "collections") {
                            this.searchCollectionData();
                        } else {
                            this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
                        }
                    });
                }
            }
        } catch (error) {
            console.error("页面加载失败:", error);
        } finally {
            this.setState({ pageLoading: false });
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    componentDidUpdate(prevProps) {
        // 当路由参数变化时更新 activeNav

        const { type: prevType } = prevProps.match.params;
        const { type: currentType } = this.props.match.params;

        if (prevType !== currentType && currentType) {
            this.setState({ activeNav: currentType });
        }
    }
    // 获取并处理目录数据
    getDirectoryList = async () => {
        try {
            this.setState({ loading: true });
            const data = await fetchData(
                urls.brandAggregation.catalogueOuter.getCatalogue
            );

            // 处理数据格式
            const treeData = this.convertToTree(data);

            const sortData = sortBySortOrder(treeData);
            console.log(sortData, "sortData");

            // 添加 "All" 选项
            const finalList = [{ id: "all", label: "All" }, ...sortData];

            this.setState({
                navItems: finalList,
                loading: false
            });
        } catch (error) {
            console.error("获取目录列表失败:", error);
            this.setState({ loading: false });
        }
    };
    // 转换为树形结构
    convertToTree = data => {
        const list = [];

        // 遍历数据构建树形结构
        for (const item of data) {
            // 转换格式
            const treeItem = {
                id: item.directoryId,
                label: item.directoryName,
                sortOrder: item.sortOrder,
            };

            const { directoryParentId } = item;
            const parentDirectory = data.find(
                directory => String(directory.directoryId) === directoryParentId
            );

            if (parentDirectory) {
                if (!parentDirectory.children) {
                    parentDirectory.children = [];
                }
                parentDirectory.children.push(treeItem);
            }

            if (item.directoryLevel === 1) {
                list.push(treeItem);
            }
        }
        console.log(list, "list 111");

        return list;
    };
    // 处理滚动事件
    handleScroll = () => {
        if (this.state.loading || !this.state.hasMore) return;
        // 获取 collection-section 元素
        const collectionSection = document.querySelector(".collection-section");
        if (!collectionSection) return;
        const rect = collectionSection.getBoundingClientRect();
        const bottomPosition = rect.bottom;
        const windowHeight = window.innerHeight;

        // 当 collection-section 底部距离视窗底部小于 50px 时触发加载
        if (bottomPosition - windowHeight < 50) {
            this.loadMore();
        }
        // const scrollHeight = document.documentElement.scrollHeight;
        // const scrollTop = document.documentElement.scrollTop;
        // const clientHeight = document.documentElement.clientHeight;

        // // 判断是否滚动到底部
        // if (scrollHeight - scrollTop - clientHeight < 50) {
        //     this.loadMore();
        // }
    };
    // 加载更多
    loadMore = () => {
        this.setState(
            prevState => ({
                pageSize: prevState.pageSize + 6, // 页码加10
                loading: true
            }),
            () => this.searchCollectionData(true)
        );
    };
    // 获取assets列表数据
    getAssetsData = async type => {
        const {
            directoryId,
            assetPageSize,
            assetPage,
            keyword,
            assetSortCol,
            activeNav
        } = this.state;
        try {
            // 调用接口获取数据
            // const response = await getAssetsDetail({
            //     assetPage,
            //     assetPageSize,
            //     keyword,
            //     sortCol: assetSortCol
            // });
            const params = {
                page: assetPage,
                pageSize: assetPageSize,
                keyword,
                directoryId: activeNav === "all" ? null : Number(activeNav),
                sortCol: assetSortCol
            };
            const response = await fetchData(
                urls.brandAggregation.assetsOuter.getAssetsDetail,
                params
            );
            // 更新状态
            this.setState({
                assetsList: response.materialList || []
            });
        } catch (error) {
            console.error("获取数据失败:", error);
            this.setState({
                assetsList: [] // 失败时设置为空数组
            });
        }
    };
    // 查询组件方法
    handleSearchKeyword = keyword => {
        // 在父组件中处理搜索关键词
        this.setState({ keyword }, () => {
            this.searchCollectionData();
            this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
        });
    };
    // 搜索合集数据的方法
    searchCollectionData = async (isLoadMore = false) => {
        if (!isLoadMore) {
            this.setState({ pageLoading: true });
        }
        const { keyword, page, pageSize, sortCol } = this.state;

        try {
            // 调用接口获取数据
            const params = {
                keyword,
                page,
                pageSize,
                sortCol
                // 其他参数
            };
            const response = await fetchData(
                urls.brandAggregation.collectionOuter.searchCollectionData,
                params
            );
            // 更新状态
            this.setState(prevState => ({
                // CollectionData: isLoadMore
                //     ? [...prevState.CollectionData, ...response.list]
                //     : response.list,
                CollectionData: response.list,
                total: response.pagination.total,
                hasMore: response.list.length === pageSize,
                loading: false,
                pageLoading: false
            }));
        } catch (error) {
            console.error("获取数据失败:", error);
            this.setState({
                CollectionData: [], // 失败时设置为空数组
                loading: false,
                pageLoading: false
            });
        }
    };
    // 添加导航点击处理方法
    handleNavClick = navId => {
        this.setState({ activeNav: navId, showDetail: false }, () => {
            // 选中后滚动到中间
            const navMenuScroll = document.querySelector(".nav-menu-scroll");
            const navItem = this.navItemRefs[navId];
            if (navMenuScroll && navItem) {
                const offset =
                    navItem.offsetLeft +
                    navItem.offsetWidth / 2 -
                    navMenuScroll.offsetWidth / 2;
                navMenuScroll.scrollTo({
                    left: offset,
                    behavior: "smooth"
                });
            }
            // 让页面滚动条滑到顶部
            window.scrollTo({ top: 0, behavior: "smooth" });
            // 在回调中调用接口，此时能获取到最新的 sortCol
            if (navId === "all") {
                this.searchCollectionData();
                this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
            } else {
                this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
            }
        });
    };
    // 添加Collection排序处理方法
    handleCollectSortChange = value => {
        const sortValue = value.value;
        this.setState({ collectSortValue: sortValue });
        // 根据选择的值获取对应的排序字段
        const sortCol = sortMapping[sortValue];

        // 调用接口时传入映射后的参数
        this.setState({ sortCol }, () => {
            // 在回调中调用接口，此时能获取到最新的 sortCol
            this.searchCollectionData();
        });
    };
    // 添加Asset排序处理方法
    handleAssetSortChange = value => {
        const sortValue = value.value;
        this.setState({ assetSortValue: sortValue });
        // 根据选择的值获取对应的排序字段
        const assetSortCol = sortMapping[sortValue];
        // 调用接口时传入映射后的参数
        this.setState({ assetSortCol }, () => {
            // 在回调中调用接口，此时能获取到最新的 sortCol
            this.cardListRef.current?.getAssetsData(); // 调用子组件的查询方法
        });
    };
    // 关闭详情页
    handleDetailClose = () => {
        this.setState({
            showDetail: false,
            collectionObj: {} // 清空对象
        });
    };
    // 跳转详情页
    handleToAssetDetail = materialCode => {
        // this.props.history.push(`/AssetDetail?materialCode=${materialCode}`);
        const isInner = window.location.href.indexOf("assets-internal") > -1;
        window.open(
            `${
                isInner ? "/assets-internal" : "/assets"
            }/brand-guidelines/detail?materialCode=${materialCode}`,
            "_blank"
        );
    };
    render() {
        const {
            navItems,
            showDetail,
            activeNav,
            assetSortValue,
            collectSortValue,
            assetsList,
            CollectionData,
            collectionObj,
            loading,
            pageLoading, // 添加页面加载状态
            keyword,
            assetSortCol
        } = this.state;
        return (
            <div className="brand-content-page">
                <div className="brand-aggregation-content">
                    <div className="brand-aggregation-title">
                        Brand Guidelines
                    </div>
                    <div style={{ width: "800px", margin: "0 auto" }}>
                        <BrandSearch
                            historyKey="brandCollectionHistory"
                            onClean={this.handleSearchKeyword}
                            onSearch={this.handleSearchKeyword}
                        />
                    </div>

                    <div className="nav-menu">
                        <div className="nav-menu-scroll">
                            {navItems.map(item => (
                                <div
                                    key={item.id}
                                    ref={el => (this.navItemRefs[item.id] = el)}
                                    className={`nav-item ${
                                        activeNav === item.id ? "active" : ""
                                    }`}
                                    onClick={() => this.handleNavClick(item.id)}
                                >
                                    {item.label}
                                </div>
                            ))}
                        </div>
                    </div>
                    {!showDetail ? (
                        <div>
                            {(activeNav === "all" ||
                                activeNav === "collections") && (
                                <div
                                    className="collection-section"
                                    style={{
                                        marginBottom: "40px"
                                    }}
                                >
                                    <div className="section-header">
                                        {activeNav !== "collections" ? (
                                            <h2>Collection</h2>
                                        ) : (
                                            <div></div>
                                        )}{" "}
                                        <div className="sort-dropdown">
                                            <Picker
                                                options={data.slice(1)}
                                                formatter={formatter}
                                                value={collectSortValue} // 添加 value 属性
                                                onChange={
                                                    this.handleCollectSortChange
                                                }
                                            ></Picker>
                                        </div>
                                    </div>

                                    {pageLoading || CollectionData === null ? (
                                        <div className="brand-content-page loading-container">
                                            <Loading
                                                direction="vertical"
                                                message="Loading..."
                                            />
                                        </div>
                                    ) : CollectionData?.length > 0 ? (
                                        <div>
                                            <div className="card-grid-brandAggregation">
                                                {CollectionData.map(
                                                    (card, index) => (
                                                        <div
                                                            key={
                                                                card.collectionId
                                                            }
                                                            className="card-brandAggregation"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showDetail: true,
                                                                    collectionObj: card
                                                                })
                                                            }
                                                        >
                                                            <div className="card-img-div-brandAggregation">
                                                                {card.relatedMaterials
                                                                    ?.slice(
                                                                        0,
                                                                        3
                                                                    ) // 只取前三个
                                                                    .map(
                                                                        (
                                                                            imgItem,
                                                                            index
                                                                        ) => (
                                                                            <img
                                                                                key={
                                                                                    index
                                                                                }
                                                                                src={
                                                                                    imgItem
                                                                                        ?.material_img_url[0]
                                                                                        ?.fileUrl
                                                                                }
                                                                                alt=""
                                                                                className="card-img-item" // 添加不同的类名以便样式控制
                                                                            />
                                                                        )
                                                                    )}
                                                            </div>
                                                            <div className="card-info">
                                                                <EllipsisTooltip
                                                                    content={
                                                                        card.collectionName
                                                                    }
                                                                    style={{
                                                                        fontSize: 20,
                                                                        fontWeight: 600,
                                                                        margin: 0,
                                                                        color:
                                                                            "#111925"
                                                                    }}
                                                                    compareWidth={
                                                                        380
                                                                    }
                                                                >
                                                                    {
                                                                        card.collectionName
                                                                    }
                                                                </EllipsisTooltip>
                                                                <div className="card-info-assets">
                                                                    {card
                                                                        ?.relatedMaterials
                                                                        ?.length ||
                                                                        0}{" "}
                                                                    assets
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            {loading && (
                                                <div className="loading">
                                                    <Loading
                                                        direction="vertical"
                                                        message="Loading more..."
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <img
                                                className="empty-state"
                                                src={noContent}
                                                alt=""
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            {activeNav !== "collections" && (
                                <div className="assets-section">
                                    <div className="section-header">
                                        {activeNav === "all" ? (
                                            <h2>Assets</h2>
                                        ) : (
                                            <div></div>
                                        )}{" "}
                                        <div className="sort-dropdown">
                                            <Picker
                                                options={data}
                                                formatter={formatter}
                                                value={assetSortValue} // 添加 value 属性
                                                onChange={
                                                    this.handleAssetSortChange
                                                }
                                            ></Picker>
                                        </div>
                                    </div>
                                    <CardList
                                        ref={this.cardListRef}
                                        sourceType={"brand-guidelines/detail"}
                                        url={
                                            urls.brandAggregation.assetsOuter
                                                .getAssetsDetail
                                        }
                                        keyword={keyword}
                                        assetSortCol={assetSortCol}
                                        activeNav={activeNav}
                                    />
                                    {/* <div className="card-grid-brandAggregation">
                                        {assetsList.map((card, index) => (
                                            <div
                                                key={card.materialId}
                                                className="card-brandAggregation"
                                                style={{
                                                    height: "273.37px"
                                                }}
                                            >
                                                <div
                                                    className="card-img-div-brandAggregation"
                                                    onClick={() =>
                                                        this.handleToAssetDetail(
                                                            card.materialCode
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src={(() => {
                                                            try {
                                                                return JSON.parse(
                                                                    card.materialImgUrl
                                                                )[0].fileUrl;
                                                            } catch (e) {
                                                                console.error(
                                                                    "解析图片URL失败:",
                                                                    e
                                                                );
                                                                return ""; // 或者返回一个默认图片URL
                                                            }
                                                        })()}
                                                        alt=""
                                                        className="card-img-item-assets" // 添加不同的类名以便样式控制
                                                    />
                                                </div>
                                                <div className="card-info">
                                                    <EllipsisTooltip
                                                        content={
                                                            card.materialName
                                                        }
                                                        style={{
                                                            fontSize: 20,
                                                            fontWeight: 600,
                                                            margin: 0
                                                        }}
                                                        compareWidth={380}
                                                    >
                                                        {card.materialName}
                                                    </EllipsisTooltip>
                                                </div>
                                            </div>
                                        ))}
                                    </div> */}
                                </div>
                            )}
                        </div>
                    ) : (
                        <CollectionDetail
                            {...this.props}
                            collectionObj={collectionObj}
                            onClose={this.handleDetailClose}
                        />
                    )}
                </div>
            </div>
        );
    }
}
